import Item, { withItemClick, withItemFocus } from '@atlaskit/item';
// We need to type this with the above type - currently this component is has "any" for its props.
export default withItemClick(withItemFocus(Item));